exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 600px){\n  body {\n    background-color: white;\n\n  }\n  img {\n    height: auto;\n    width: 100%;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/node_modules/css-loader?{"sourceMap":false,"import":false}!/Users/juliusbade/Desktop/UnderArmour-Rebuild/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/juliusbade/Desktop/UnderArmour-Rebuild/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"import":false}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles